import React from 'react'
import Link from '@material-ui/core/Link'


export default function LinkExternal({ href, label, ...props }) {
  return (
    <Link href={href || label || ''} target="_blank" rel="noopener noreferrer" color='textPrimary' {...props}>{label || ''}</Link>
  )
}